module.exports = __webpack_public_path__ + "static/media/Outfit_900Black.31732721.ttf";